import { render, staticRenderFns } from "./Dot.vue?vue&type=template&id=061450f5&scoped=true&"
import script from "./Dot.vue?vue&type=script&lang=js&"
export * from "./Dot.vue?vue&type=script&lang=js&"
import style0 from "./Dot.vue?vue&type=style&index=0&id=061450f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061450f5",
  null
  
)

export default component.exports